import type { MapboxSuggestion, Suggestion } from '../types';

export function mapMapboxSuggestion(mapboxSuggestion: MapboxSuggestion): Suggestion {
  return {
    id: mapboxSuggestion.mapbox_id,
    type: mapboxSuggestion.feature_type,
    country: mapboxSuggestion.context.country.name,
    city: mapboxSuggestion.context.place.name ?? mapboxSuggestion.context.locality?.name,
    zipCode: mapboxSuggestion.context.postcode.name,
    street:
      mapboxSuggestion.context.address?.address_number ??
      mapboxSuggestion.context.street?.name ??
      '',
    // There is this bug in API, street name and number are swapped.
    houseNumber: mapboxSuggestion.context.address?.street_name,
    formattedAddress:
      mapboxSuggestion.full_address ??
      `${mapboxSuggestion.name}, ${mapboxSuggestion.place_formatted}`,
  };
}
